<template>
  <v-card :color="color">
    <v-card-title
      :class="{
        'white--text': !label.includes('lighten'),
      }"
      >{{ label }}</v-card-title
    >
  </v-card>
</template>

<script>
export default {
  props: {
    color: String,
    label: String,
  },
}
</script>
